import styled from 'styled-components';

export const StyledBroadsiderInventoryItem = styled.div`
  width: 100%;
  height: ${({ theme }) => theme.avatarSize};
  cursor: pointer;
  position: relative;

  &:hover {
    .broadsider-inv-item-border {
      background: ${({ theme, $selected }) => $selected ? theme.selection : 'white'};
    }

    .broadsider-inv-item-internal-border {
      padding: ${({ theme }) => theme.buttonFrameWidth};
    }

    .broadsider-inv-item-decorator {
      div {
        background: ${({ theme, $selected }) => $selected ? theme.selectionGreen : theme.selectionBlue};
      }
    }

    .broadsider-inv-item-image {
      scale: 1.2;
    }

    .broadsider-inv-item-type {
      transform: translateX(0px);
    }

    .broadsider-inv-item-number {
      opacity: 1.0;
    }

    .broadsider-inv-item-action-icon {
      opacity: 1.0;
    }

    .broadsider-inv-item-name {
      transform: translateX(0px);
    }
  }

  .broadsider-inv-item-border {
    padding: ${({ theme }) => theme.buttonFrameWidth};
    background: ${({ theme, $selected }) => $selected ? theme.selection : 'transparent'};
    clip-path: polygon(24px 0, 100% 0, 100% 100%, 0 100%, 0% 24px);
    width: 100%;
    height: 100%;
  }

  .broadsider-inv-item-internal-border {
    padding: ${({ theme }) => theme.buttonFrameWidth};
    background: ${({ theme }) => theme.borderDark};
    clip-path: polygon(24px 0, 100% 0, 100% 100%, 0 100%, 0% 24px);
    width: 100%;
    height: 100%;
  }

  .broadsider-inv-item-content {
    width: 100%;
    height: 100%;
    position: relative;
    background: ${({ theme }) => theme.brightBlue};
    clip-path: polygon(23px 0, 100% 0, 100% 100%, 0 100%, 0% 23px);
  }

  .broadsider-inv-item-content-bg {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  .broadsider-inv-item-image-wrapper {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 8px;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }

  .broadsider-inv-item-multi-image-wrapper > * {
    margin-right: -4rem;
  }

  .broadsider-inv-item-multi-image-wrapper > *:last-child {
    margin-right: 0;
  }

  .broadsider-inv-item-image {
    transition: linear 0.2s;
    max-width: 100%;
    height: 100%;
  }

  .broadsider-inv-item-image-third-party {
    transition: linear 0.2s;
    max-width: 120%;
  }

  .broadsider-inv-item-decorator {
    width: 20px;
    height: 20px;
    background: ${({ theme }) => theme.borderDark};
    clip-path: polygon(100% 0, 0 0, 0 100%);
    position: absolute;
    top: ${({ theme }) => theme.buttonFrameWidth};
    left: ${({ theme }) => theme.buttonFrameWidth};
    padding: 2px;
    z-index: 201;

    div {
      clip-path: polygon(100% 0, 0 0, 0 100%);
      width: 80%;
      height: 80%;
      background: ${({ theme, $selected }) => $selected ? theme.selectionGreen : theme.background};
    }
  }

  .broadsider-inv-item-type {
    position: absolute;
    top: 8px;
    right: 8px;
    font-family: "NeueMachina";
    font-size: 1rem;
    color: white;
    text-transform: lowercase;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    transform: ${({ $highlighted, theme }) => $highlighted ? 'translateX(0px)' : 'translateX(' + theme.invNumberSize + ')'};
    transition: linear 0.2s;
  }

  .broadsider-inv-item-info {
    position: absolute;
    top: 0;
    right: 0;
  }

  .broadsider-inv-item-type-name {
    opacity: 0.4;
  }

  .broadsider-inv-item-number {
    opacity: ${({ $highlighted }) => $highlighted ? '1.0' : '0.0'};
    width: ${({ theme }) => theme.invNumberSize};
    text-align: end;
    overflow: hidden;

    span {
      font-family: "BebasNeue";
      font-size: 1.25rem;
      opacity: 0.4;
    }

    .number {
      color: ${({ theme }) => theme.selection};
      opacity: 1.0;
    }
  }

  .broadsider-inv-item-name {
    position: absolute;
    bottom: 8px;
    left: 8px;
    transform: ${({ $highlighted, theme }) => $highlighted ? 'translateX(0px)' : 'translateX(calc(-' + theme.actionIconSize + ' - 8px))'};
    transition: linear 0.2s;
    font-family: "BebasNeue";
    font-size: 1.25rem;
    color: white;
    text-transform: uppercase;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    justify-content: space-between;
    max-height: ${({ theme }) => theme.actionIconSize};
  }

  .broadsider-inv-item-name-label {
    padding-top: 4px;
  }

  .broadsider-inv-item-action-icon {
    width: ${({ theme }) => theme.actionIconSize};
    height: ${({ theme }) => theme.actionIconSize};
    transition: opacity linear 0.2s;
    opacity: ${({ $highlighted }) => $highlighted ? '1.0' : '0.0'};

    img {
      width: 100%;
      height: 100%;
    }
  }

  .broadsider-inv-item-info-button {
    width: ${({ theme }) => theme.smallButtonSize};
    height: ${({ theme }) => theme.smallButtonSize};
    padding: ${({ theme }) => theme.buttonFrameWidth};
    position: relative;

    .broadsider-inv-item-info-button-corner {
      position: absolute;
      border: solid ${({ theme }) => theme.buttonFrameWidth} transparent;
      top: 0;
      bottom: 0;
      width: 8px
    }

    .broadsider-inv-item-info-button-corner-l {
      border-right: none;
      left: 0;
    }

    .broadsider-inv-item-info-button-corner-r {
      border-left: none;
      right: 0;
    }

    &:hover {
      .broadsider-inv-item-info-button-corner {
        border: solid ${({ theme }) => theme.buttonFrameWidth} white;
      }

      .broadsider-inv-item-info-button-corner-l {
        border-right: none;
      }

      .broadsider-inv-item-info-button-corner-r {
        border-left: none;
      }

      .broadsider-inv-item-info-button-content {
        background: ${({ theme }) => theme.buttonBrightBlue};
      }
  }

  .broadsider-inv-item-info-button-content {
    width: 100%;
    height: 100%;
    padding: 4px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    transition: background linear .2s;
    background: ${({ theme }) => theme.traitBorder};
    img {
      height: ${({ theme }) => theme.actionIconSize};
      width: ${({ theme }) => theme.actionIconSize};
    }
  }
`;
